import { CloseCircleOutlined } from "@ant-design/icons";
import type { ConceptBrief } from "./ConceptType";
import "./ConceptSelectedBar.css";

type Props = {
  concepts: ConceptBrief[];
  onRemove?: (code: string) => void;
  /** 传入时在右侧展示清空按钮 */
  onClear?: () => void;
  className?: string;
};

export default function ConceptSelectedBar(props: Props): JSX.Element | null {
  const { concepts, onRemove, onClear, className } = props;
  if (concepts.length === 0) {
    return null;
  }

  const rootClass = ["lf-concept-selected-bar", className].filter(Boolean).join(" ");

  return (
    <div className={rootClass} aria-label="已选概念">
      <span className="lf-concept-selected-bar__label">已选</span>
      <div className="lf-concept-selected-bar__chips">
        {concepts.map((c) => (
          <button
            key={c.code}
            type="button"
            className="lf-concept-selected-bar__chip"
            onClick={onRemove ? () => onRemove(c.code) : undefined}
            disabled={!onRemove}
          >
            <span className="lf-concept-selected-bar__chip-name">{c.name}</span>
            {onRemove ? (
              <span className="lf-concept-selected-bar__chip-x" aria-hidden>
                ×
              </span>
            ) : null}
          </button>
        ))}
      </div>
      {onClear ? (
        <button
          type="button"
          className="lf-concept-selected-bar__clear"
          onClick={onClear}
          aria-label="清空已选概念"
        >
          <CloseCircleOutlined />
        </button>
      ) : null}
    </div>
  );
}
